import { createActionTypeModel } from "../../../store/global/action-model";

export const DTGPTChats = createActionTypeModel('DTGPTChats');
export const SET_SHOW_CHATS = 'SET_SHOW_CHATS';